import { useState, useEffect, useRef } from "react";
import Menu from "../components/Menu";
import ImageZoom from "../components/ImageZoom";
import { motion, AnimatePresence } from "framer-motion";
import { Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { Helmet } from "react-helmet";

export default function Home() {
  const [showText, setShowText] = useState(false);
  const graySectionRef = useRef(null);
  const [photo, setPhoto] = useState([]);
  const API_BASE = "https://tomaszfotograf.pl";
  const [ipAddress, setIPAddress] = useState("");

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        setIPAddress(data.ip);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    fetch("save_ip.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ip: ipAddress }),
    });
  }, [ipAddress]);

  useEffect(() => {
    const fetchPhotoHome = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/photohome`);
        if (!res.ok) throw new Error("Błąd pobierania danych z API");
        const data = await res.json();
        console.log("data: ", data[0].filename);
        setPhoto(`${API_BASE}/files/${data[0].filename}`);
      } catch (err) {
        console.error("Błąd:", err);
      } finally {
        console.log("ok");
      }
    };

    fetchPhotoHome();
  }, []);

  useEffect(() => {
    const textTimer = setTimeout(() => setShowText(true), 900);
    const imageTimer = setTimeout(() => 1600);
    return () => {
      clearTimeout(textTimer);
      clearTimeout(imageTimer);
    };
  }, []);

  useEffect(() => {
    const textObserver = new IntersectionObserver(
      ([entry]) => {
        setShowText(entry.isIntersecting);
      },
      { threshold: 0.4 }
    );
    if (graySectionRef.current) textObserver.observe(graySectionRef.current);
    return () => {
      textObserver.disconnect();
    };
  }, []);

  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  //sameAs: ["https://www.instagram.com/", "https://www.facebook.com/"],

  return (
    <>
      <Helmet>
        <title>Fotografia wnętrz i nieruchomości | Tomasz Fotograf</title>
        <meta
          name="description"
          content="Profesjonalna fotografia wnętrz, nieruchomości, apartamentów i hoteli. Zdjęcia zwiększające sprzedaż ofert."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            name: "Tomasz Fotograf - fotografia nieruchomości",
            url: "https://tomaszfotograf.pl",
            image: "https://tomaszfotograf.pl/files/zxd.jpg",
            description:
              "Profesjonalna fotografia wnętrz i nieruchomości w Warszawie i okolicach.",
            areaServed: {
              "@type": "AdministrativeArea",
              name: "Warszawa i okolice",
            },
            address: {
              "@type": "PostalAddress",
              addressCountry: "PL",
            },
          })}
        </script>
      </Helmet>
      <Menu />
      <div className="fullpage">
        <section className="section section-dark section-home">
          <motion.div
            className="fade-in-text"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={textVariants}
          >
            <Row>
              <Col sm={12} md={4}>
                <p className="h1a">
                  PROFESJONALNA FOTOGRAFIA<br></br> WNĘTRZ I&nbsp;NIERUCHOMOŚCI
                </p>
              </Col>
              <Col sm={12} md={8}>
                <ImageZoom src={photo} alt="title" />
              </Col>
            </Row>
          </motion.div>
        </section>
        <section className="section section-gray" ref={graySectionRef}>
          <AnimatePresence>
            {showText && (
              <motion.div
                className="fade-in-text"
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={textVariants}
              >
                <Row>
                  <Col className="d-flex" md={4}>
                    <p className="h1a">
                      FILMOWE PODEJŚCIE DO PREZENTACJI WNĘTRZ
                    </p>
                  </Col>
                  <Col md={8}>
                    <p className="h4a">
                      Specjalizuję się w profesjonalnej fotografii nieruchomości
                      na terenie Warszawy i okolic.
                    </p>
                    <p className="h4a">
                      Łączę doświadczenie zdobyte w branży filmowej i reklamowej
                      z techniczną precyzją oraz umiejętnością budowania
                      nastroju światłem. Dzięki temu każde wnętrze prezentuję
                      tak, jak kadr z dobrze wyreżyserowanego filmu.
                    </p>
                    <p className="h4a">
                      Pracuję dla agentów nieruchomości, właścicieli mieszkań,
                      deweloperów, projektantów wnętrz, architektów, producentów
                      mebli, hoteli, pensjonatów i restauracji.{" "}
                    </p>
                    <p className="h4a">
                      Tworzę zdjęcia, filmy oraz ujęcia dronem, które zwiększają
                      atrakcyjność ogłoszeń i szybciej przyciągają klientów.{" "}
                    </p>
                    <p className="h4a">
                      ✔ Zdjęcia dostarczam w ciągu 24 godzin.{" "}
                    </p>
                    <p className="h4a">
                      ✔ Dojazd do 30 km od centrum Warszawy — w cenie.{" "}
                    </p>
                    <p className="h4a">
                      ✔ Dodatkowo oferuję staging wnętrz: zwykły, premium oraz
                      wirtualny.
                    </p>
                  </Col>
                </Row>
              </motion.div>
            )}
          </AnimatePresence>
        </section>
      </div>
    </>
  );
}
